import { PageError } from '@twigeducation/ts-fe-components';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledPageError = styled(PageError)`
    margin: 10% 0;
`;
